<template>
	<div class="study">
		<publicHeader></publicHeader>
		<careerHeader :careerNav ="careerNav"></careerHeader>
		<div class="career_adver">
			<img :src="careerAdver.img" class="block" />
		</div>
		<div class="choice_cont w1200">
			<router-link to="/choice_subject" class="choice_cont_list radius8">
				<img src="../../../static/career_select_01.png" class="block radius8" />
				<div class="choice_cont_list_text">
					<h3 class="f20px cl_violet clip">选科查询系统</h3>
					<p class="cl_dark clip mat5">教育部颁布的本专科专业大全，任你一一翻阅</p>
				</div>
			</router-link>
			<!-- <router-link to="/contrast" class="choice_cont_list radius8">
				<img src="../../../static/career_select_02.png" class="block radius8" />
				<div class="choice_cont_list_text">
					<h3 class="f20px cl_violet clip">科目对比分析</h3>
					<p class="cl_dark clip mat5">国家人力资源部颁布的职业大全，供你全国了解职业</p>
				</div>
			</router-link> -->
			<router-link to="/choice_collect" class="choice_cont_list radius8">
				<img src="../../../static/career_select_03.png" class="block radius8" />
				<div class="choice_cont_list_text">
					<h3 class="f20px cl_violet clip">我的收藏</h3>
					<p class="cl_dark clip mat5">全国近三千所大学，供你一一查阅</p>
				</div>
			</router-link>
		</div>
		<vfooter></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import careerHeader from '../../components/career_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'choice',
		components: {
			publicHeader,
			careerHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				careerNav: 1,	//导航
				careerAdver: { //广告
					url: "",
					img: require("../../../static/career_banner_02.png"),
				},
			}
		},
		mounted() {
			
		},
		created() {
			
		},
		methods: {
			
		},
	}
</script>

<style>
</style>
